module.exports = __webpack_public_path__ + "a5e4960f34546ef84896482510192a2e.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/header/components/images/logout-gray.png
 ** module id = 1399
 ** module chunks = 0
 **/